import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionReveal } from './components/SolutionReveal';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorks } from './components/HowItWorks';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusSection } from './components/BonusSection';
import { SavingsCalculator } from './components/SavingsCalculator';
import { IsThisForYou } from './components/IsThisForYou';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalSummary } from './components/FinalSummary';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
/* ─── Meta Pixel ───
   Queue is initialized synchronously so events are captured immediately.
   The actual fbevents.js script loads async — queued events fire on load. */
function initFBPixel() {
  if (typeof window === 'undefined' || window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  window.fbq('init', '1722508149156041');
  window.fbq('track', 'PageView');
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}
export function App() {
  useEffect(() => {
    document.title = '200 Recetas Inteligentes 15D';
    // Set Open Graph meta tags for WhatsApp/social previews
    const metaTags: Record<string, string> = {
      'og:title': '200 Recetas Inteligentes 15D',
      'og:description': 'Prepará 15 días de comidas en 2 horas. +200 recetas listas para freezer. Sin dietas estrictas ni delivery.',
      'og:type': 'website',
      'og:image': 'https://cdn.magicpatterns.com/uploads/8ftLEeK2RTLSdnhb697fhV/Mockup_Oferta.png',
      description: 'Prepará 15 días de comidas en 2 horas. +200 recetas listas para freezer. Sin dietas estrictas ni delivery.'
    };
    Object.entries(metaTags).forEach(([key, value]) => {
      const isOg = key.startsWith('og:');
      const selector = isOg ? `meta[property="${key}"]` : `meta[name="${key}"]`;
      let tag = document.querySelector(selector) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        if (isOg) {
          tag.setAttribute('property', key);
        } else {
          tag.setAttribute('name', key);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', value);
    });
    initFBPixel();
  }, []);
  return <div className="min-h-screen bg-bg-base font-body text-text-primary selection:bg-primary/20" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1722508149156041&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <SolutionReveal data-id="element-6" />
        <BenefitsSection data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <BonusSection data-id="element-10" />
        <SavingsCalculator data-id="element-11" />
        <IsThisForYou data-id="element-12" />
        <TestimonialsSection data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FinalSummary data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}